import { baseApi } from 'sama-shared';
import type {
  FinancialReport,
  FinancialTimeseriesResponse,
  PartnerFinancialReport,
  TopPartnersResponse,
  DeliveryFinancialReport,
  TopDeliveryProvidersResponse,
  DeliveryTimeseriesResponse,
} from '../types/admin';
import type {
  GetPartnerReportParams,
  GetReportParams,
  GetTimeseriesParams,
  GetTopPartnersParams,
} from '../types/api';

export const reportsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAdminReport: builder.query<PartnerFinancialReport, GetPartnerReportParams>({
      query: (params) => ({
        url: '/admin/report',
        method: 'GET',
        params,
      }),
      providesTags: ['Report'],
    }),

    getFinancialReport: builder.query<FinancialReport, GetReportParams>({
      query: (params) => ({
        url: '/admin/report/financial/kpi/summary',
        method: 'GET',
        params,
      }),
      providesTags: ['Report'],
    }),

    getTopPartners: builder.query<TopPartnersResponse, GetTopPartnersParams>({
      query: ({ page = 1, limit = 10, ...params }) => ({
        url: '/admin/report/financial/kpi/top-partners',
        method: 'GET',
        params: { page, limit, ...params },
      }),
      providesTags: ['Report'],
    }),

    getKpiTimeseries: builder.query<FinancialTimeseriesResponse, GetTimeseriesParams>({
      query: ({ granularity = 'day', ...params }) => ({
        url: '/admin/report/financial/kpi/timeseries',
        method: 'GET',
        params: { granularity, ...params },
      }),
      providesTags: ['Report'],
    }),

    getDeliveryFinancialReport: builder.query<DeliveryFinancialReport, GetReportParams>({
      query: (params) => ({
        url: '/admin/report/financial/kpi/delivery/summary',
        method: 'GET',
        params,
      }),
      providesTags: ['Report'],
    }),

    getTopDeliveryProviders: builder.query<TopDeliveryProvidersResponse, GetTopPartnersParams>({
      query: ({ page = 1, limit = 10, ...params }) => ({
        url: '/admin/report/financial/kpi/delivery/top-providers',
        method: 'GET',
        params: { page, limit, ...params },
      }),
      providesTags: ['Report'],
    }),

    getDeliveryKpiTimeseries: builder.query<DeliveryTimeseriesResponse, GetTimeseriesParams>({
      query: ({ granularity = 'day', ...params }) => ({
        url: '/admin/report/financial/kpi/delivery/timeseries',
        method: 'GET',
        params: { granularity, ...params },
      }),
      providesTags: ['Report'],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetAdminReportQuery,
  useGetFinancialReportQuery,
  useGetTopPartnersQuery,
  useGetKpiTimeseriesQuery,
  useGetDeliveryFinancialReportQuery,
  useGetTopDeliveryProvidersQuery,
  useGetDeliveryKpiTimeseriesQuery,
} = reportsApi;
